import type { AxiosResponse } from "axios";

import type { IUser } from "../../../types";
import type { DatevExportFormValues } from "./commands/DatevExport";
import type { ExportTransactionsFormValues } from "./commands/ExportTransactions";
import type { ExportEURTransactionsFormValues } from "./commands/ExportEURTransactions";
import type { ResetDeclarationApprovalValues } from "./commands/ResetDeclarationApproval";
import type { ResetUserTaxCaseFormValues } from "./commands/ResetUserTaxCase";
import type { GenerateInviteLinkValues } from "./commands/GenerateInviteLink";
import type { ExportSmartaBankingTransactionsFormValues } from "./commands/ExportSmartaBankingTransactions";

export enum Command {
  ExportTransactions = "exportTransactions",
  DeleteEndlessDatevExports = "deleteEndlessDatevExports",
  ExportEURTransactions = "exportEURTransactions",
  DatevExport = "datevExport",
  ResetDeclarationApproval = "resetDeclarationApproval",
  ResetUserTaxCase = "resetUserTaxCase",
  GenerateInviteLink = "generateInviteLink",
  ExportSmartaBankingTransactions = "exportSmartaBankingTransactions",
}

export type CommandOption = {
  label: string;
  value: Command;
};

export type CommandFormValues =
  | ExportTransactionsFormValues
  | DatevExportFormValues
  | ResetDeclarationApprovalValues
  | ExportEURTransactionsFormValues
  | ResetUserTaxCaseFormValues
  | GenerateInviteLinkValues
  | ExportSmartaBankingTransactionsFormValues;

export type CommandMethod = (
  user: IUser,
  values: CommandFormValues
) => Promise<AxiosResponse>;

export type CommandSuccessHandler = (
  response: AxiosResponse
) => React.ReactNode;

export type CommandConfig = {
  labelKey: string;
  component?: React.ComponentType<any>;
  initialValues?: Partial<CommandFormValues>;
  method?: CommandMethod;
  onSuccess?: CommandSuccessHandler;
};
